import { DataBox } from './DataBox'
import { baseAuthModel } from '../authModel'
import { PageHeader } from './PageHeader'
import { EditAuthModal } from './editAuthModal'

export function BaseAuth() {
    const { editCarVisible } = baseAuthModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {editCarVisible && <EditAuthModal />}
        </>
    )
}
